/**
 * Walidator formatu loginu (username) — drugi identyfikator logowania obok maila.
 *
 * Zasady (ADR-0022):
 *  - 3-32 znaków
 *  - lowercase ASCII alphanumeric + kropka/podkreślenie/myślnik
 *  - bez punktacji na pierwszym i ostatnim znaku
 *
 * Używany przez backend (walidacja przy invite/edit/login) i frontend
 * (walidacja client-side w formularzach).
 */

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 32;

export const USERNAME_REGEX = /^[a-z0-9]([a-z0-9._-]{1,30})[a-z0-9]$/;

export function isValidUsername(value: string): boolean {
  return USERNAME_REGEX.test(value);
}
